module.exports = __webpack_public_path__ + "10d27a0b88d18565b952183f2327b05b.MP3";